import React, { useState, useEffect } from "react";
import toBoolean from "../../lib/iprs-react-library/src/util/toBoolean";
import { LoadingIndicator, TwoSwitch, decodeJWT } from '../../lib/iprs-react-library/src/index.js';
import { getURLSearchParam } from '../../lib/iprs-react-library/src/index';
import "./styles.css";

const ClinicSlotAvailability = ({ api }) => {
    const [slots, setSlots] = useState([]);
    const queryParams = new URLSearchParams(window.location.search);
    const facilityID = queryParams.get("FacilityID");
    const facilityName = queryParams.get("FacilityName");
    const token = queryParams.get("Token");
    const slotsParam = queryParams.get("slots");
    const brandingInfo = queryParams.get("brandingInfo");
    const caseid = queryParams.get("caseid");
    const VenueId = queryParams.get("VenueId");
    const postcode = queryParams.get("postcode");
    const address = queryParams.get("Address");
    let addressValue = null;
    const [isConfirming, setIsConfirming] = useState(false);

    try {
        addressValue = JSON.parse(decodeURIComponent(address));
    } catch (e) {
        console.warn("Failed to parse address:", e);
        addressValue = address;
    }

    const [isClinicConfirmLoading, setIsClinicConfirmLoading] = useState(false);
    const [confirmClinicErrorMessage, setConfirmClinicErrorMessage] = useState("");
    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [monthOffset, setMonthOffset] = useState(0);


    const Spinner = () => {
        const loaderCssOverride = {
            borderColor: "rgb(255 210 239 / 66%) rgb(255 210 239 / 66%) #dd6cae"
        };

        return (
            <div className="loader">
                <LoadingIndicator
                    loading={true}
                    color={"#BD5196"}
                    speed={0.5}
                    size={42}
                    cssOverride={loaderCssOverride}
                />
                <p style={{ marginTop: "26px" }}>Please wait...</p>
            </div>
        );
    };

    useEffect(() => {
        setLoading(true);
        const ParamSlots = { VenueId: VenueId, caseid: caseid };
        api.transact("GetClinicAvailableSlots", ParamSlots)
            .then(r => {
                if (!r?.apiOK || r?.apiStatus !== "OK") {
                    throw new Error("Failed to get clinic slots");
                }
                setSlots(r.apiResult?.AvailableSlots || []);
            })
            .catch(e => {
                console.error(e);
                alert("Something went wrong while trying to get clinic slots");
            })
            .finally(() => {
                setLoading(false);
            });
    }, [slotsParam]);

    const getWeekDays = (startDate = new Date()) => {
        const days = [];
        const start = new Date(startDate);
        start.setMonth(start.getMonth() + monthOffset); 
        start.setDate(1); 
        for (let i = 0; i < 60; i++) {
            const d = new Date(start);
            d.setDate(start.getDate() + i);
            days.push(d);
        }
        return days;
    };
    const getFortnightDays = (offset = 0) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const start = new Date(today);
        start.setDate(today.getDate() + offset * 14);

        const days = [];
        for (let i = 0; i < 14; i++) {
            const d = new Date(start);
            d.setDate(start.getDate() + i);
            days.push(d);
        }
        return days;
    };
    const getMonthDays = (offset = 0) => {
        const today = new Date();
        const start = new Date(today.getFullYear(), today.getMonth() + offset, 1);
        const end = new Date(today.getFullYear(), today.getMonth() + offset + 1, 0); 
        const days = [];
        for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
            if (d >= new Date(today.setHours(0, 0, 0, 0))) {
                days.push(new Date(d));
            }
        }
        return days;
    };

    const chunkIntoWeeks = (days) => {
        const weeks = [];
        for (let i = 0; i < days.length; i += 7) {
            const week = days.slice(i, i + 7);
            while (week.length < 7) {
                week.push(null);
            }
            weeks.push(week);
        }
        return weeks;
    };

    const monthDays = getMonthDays(monthOffset);
    const [fortnightOffset, setFortnightOffset] = useState(0);
    const fortnightDays = getFortnightDays(fortnightOffset);
    const weeks = chunkIntoWeeks(fortnightDays);

    const openModal = (day) => {
        setSelectedDay(day);
        setIsModalOpen(true);
        setSelectedSlot(null);
    };

    const handleConfirmSlot = (selectedSlot, facilityID, facilityName, address) => {
        if (!selectedSlot) return alert("Please select a slot!");

        const paramsReserve = { selectedSlot: selectedSlot, caseid: caseid };
        setIsConfirming(true);
        api.transact("ReserveOPMSlots", paramsReserve)
            .then(r => {
                if (!r?.apiOK || r?.apiStatus !== "OK") {
                    throw new Error("Failed to reserve slot");
                }
                if (toBoolean(brandingInfo?.PaymentCardRequired, true)) {
                    const paramsPayment = { caseid: caseid };

                    return api.transact("IsPaymentCardRequired", paramsPayment)
                        .then(resp => resp.apiResult)
                        .then(result => {
                            const isPaymentCardRequired = Object.hasOwn(result, 'IsPaymentCardRequiredNew')
                                ? result.IsPaymentCardRequiredNew
                                : true;

                            redirectToPayment(api.getToken(), facilityID, isPaymentCardRequired, selectedSlot, facilityName, address);
                            setIsModalOpen(false);
                        });
                } else {
                    const addressDetails = encodeURIComponent(JSON.stringify(address));
                    const urlForBookingSummary = '../Bookingsummary/'
                        + '?Token=' + api.getToken()
                        + '&FacilityID=' + facilityID
                        + '&FacilityName=' + facilityName
                        + '&Address=' + addressDetails
                        + '&postcode=' + encodeURIComponent(postcode)
                        + '&selectedSlot=' + encodeURIComponent(JSON.stringify(selectedSlot ?? null));

                    window.location.replace(urlForBookingSummary);
                    setIsModalOpen(false);
                }
            })
            .catch(e => {
                console.error(e);
                setIsClinicConfirmLoading(false);
                alert("Something went wrong while confirming your slot");
            })
            .finally(() => {
                setIsConfirming(false);
            });
    };

    const redirectToPayment = (token, facilityID, isPaymentCardRequired, selectedSlot, facilityName, address) => {
        if (isPaymentCardRequired) {
            setIsClinicConfirmLoading(false);
            const urlForPayment = '../payment/'
                + '?Token=' + token
                + '&FacilityID=' + facilityID
                + '&postcode=' + encodeURIComponent(postcode)
                + '&FacilityName=' + encodeURIComponent(facilityName)
                + '&Address=' + encodeURIComponent(address)
                + '&selectedSlot=' + encodeURIComponent(JSON.stringify(selectedSlot ?? null));
            window.location.replace(urlForPayment);
        } else {
            //apiMakeReferral(token, facilityID, selectedSlot);
            const addressDetails = encodeURIComponent(JSON.stringify(address));
            const urlForBookingSummary = '../Bookingsummary/'
                + '?Token=' + api.getToken()
                + '&FacilityID=' + facilityID
                + '&FacilityName=' + facilityName
                + '&Address=' + addressDetails
                + '&postcode=' + encodeURIComponent(postcode)
                + '&selectedSlot=' + encodeURIComponent(JSON.stringify(selectedSlot ?? null));

            window.location.replace(urlForBookingSummary);
        }
    };

    const apiMakeReferral = (token, facilityID, selectedSlot) => {
        const params = {
            "Token": token,
            "FacilityID": facilityID,
            "SelectedSlot": selectedSlot
        };
        api.transact("MakeReferral", params)
            .then(r => {
                console.log("MakeReferral: ", r);
                const urlForFeedBack = '../feedback/'
                    + '?Token=' + token
                    + '&FacilityID=' + facilityID
                    + '&SelectedSlot=' + encodeURIComponent(JSON.stringify(selectedSlot ?? null))
                window.location.replace(urlForFeedBack);
                setIsClinicConfirmLoading(false);
            })
            .catch(error => {
                console.log(error.message);
                setConfirmClinicErrorMessage(error.message);
                setIsClinicConfirmLoading(false);
            });
    };
    const proceedToPaymentOrSummary = (facilityID, facilityName, address, selectedSlot) => {
        if (toBoolean(brandingInfo?.PaymentCardRequired, true)) {
            const paramsPayment = { caseid: caseid };

            return api.transact("IsPaymentCardRequired", paramsPayment)
                .then(resp => resp.apiResult)
                .then(result => {
                    const isPaymentCardRequired = Object.hasOwn(result, 'IsPaymentCardRequiredNew')
                        ? result.IsPaymentCardRequiredNew
                        : true;

                    redirectToPayment(api.getToken(), facilityID, isPaymentCardRequired, selectedSlot, facilityName, address);
                    setIsModalOpen(false);
                });
        } else {
            const addressDetails = encodeURIComponent(JSON.stringify(address));
            const urlForBookingSummary = '../Bookingsummary/'
                + '?Token=' + api.getToken()
                + '&FacilityID=' + facilityID
                + '&FacilityName=' + facilityName
                + '&Address=' + addressDetails
                + '&postcode=' + encodeURIComponent(postcode)
                + '&selectedSlot=' + encodeURIComponent(JSON.stringify(selectedSlot ?? null));

            window.location.replace(urlForBookingSummary);
            setIsModalOpen(false);
        }
    }
    const getSlotsForDay = (day) => {
        if (!slots || !Array.isArray(slots)) return [];
        return slots.filter((slot) => {
            const slotDate = new Date(slot.startDateTime);
            return (
                slotDate.getFullYear() === day.getFullYear() &&
                slotDate.getMonth() === day.getMonth() &&
                slotDate.getDate() === day.getDate()
            );
        });
    };

    function redirectBackToReferral() {

        let referralUrl = '../Referral' + '?Token=' + api.getToken();
        const postcodeSearch = getURLSearchParam("postcode");
        if (typeof postcodeSearch === 'string' && postcodeSearch !== '') {
            referralUrl += "&postcode=" + encodeURIComponent(postcodeSearch);
        }

        window.location.replace(referralUrl);
    }
    const handleNextMonth = () => {
        setMonthOffset(prev => {
            if (prev >= 2) return prev; // Prevent going beyond 2 months ahead
            return prev + 1;
        });
    };
    const handlePrevMonth = () => setMonthOffset(prev => Math.max(prev - 1, 0));
    const handleNextFortnight = () => {
        setFortnightOffset(prev => prev + 1); 
    };
    const handlePrevFortnight = () => {
        setFortnightOffset(prev => Math.max(prev - 1, 0));
    };
    const startDate = fortnightDays[0];
    const endDate = fortnightDays[fortnightDays.length - 1];
    const dateRangeLabel = `${startDate.toLocaleDateString("default", {
        day: "numeric",
        month: "long"
    })} - ${endDate.toLocaleDateString("default", {
        day: "numeric",
        month: "long",
        year: "numeric"
    })}`;
    return (
        <div className="clinicsslots-container">
            <div className="clinicsslots-header">
                {!loading && (
                    <button
                        type="button"
                        className="clinicsslots-back-btn"
                        onClick={redirectBackToReferral}

                    >
                        &larr; Back To Search
                    </button>
                )}
                <h1 className="clinicsslots-title">Slot Availability : {facilityName} </h1>

            </div>
            <div className="clinicsslots-legend">
                <div className="legend-item">
                    <span className="legend-color available"></span> Available
                </div>
                <div className="legend-item">
                    <span className="legend-color unavailable"></span> Unavailable
                </div>
            </div>
            {!loading && (
                <div className="navigation" style={{ display: "flex", justifyContent: "space-between", margin: "10px 0" }}>
                    <button onClick={handlePrevFortnight} disabled={fortnightOffset === 0}> &laquo; Previous</button>
                    <button onClick={handleNextFortnight} disabled={fortnightOffset >= 1}>Next &raquo;</button>
                </div>
            )}
            {loading ? (
                <Spinner />
            ) : (
                <div className="clinicsslots-weeks">
                    {weeks.map((week, wIdx) => {
                        return (
                            <div key={wIdx} className="clinicsslots-week-block">
                                {wIdx === 0 && (
                                    <div className="clinicsslots-month-label">{dateRangeLabel}</div>
                                )}

                                <div className="clinicsslots-week">
                                    {week.map((day, dIdx) => {
                                        if (!day)
                                            return <div key={dIdx} className="clinicsslots-day empty"></div>;
                                        const daySlots = getSlotsForDay(day);
                                        return (
                                            <div
                                                key={dIdx}
                                                className={`clinicsslots-day ${daySlots.length > 0 ? "available" : "unavailable"
                                                    }`}
                                                onClick={() => daySlots.length > 0 && openModal(day)}
                                            >
                                                <span className="day-label">
                                                    {day.toLocaleDateString("default", { weekday: "short" })}
                                                </span>
                                                <span className="day-number">{day.getDate()}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
            {isModalOpen && (
                <div className="clinicsslots-modal-overlay">
                    <div className="clinicsslots-modal">
                        <h3>{selectedDay.toDateString()} - Select a Slot</h3>
                        <div className="clinicsslots-slots-list">
                            {getSlotsForDay(selectedDay).map((slot) => (
                                <button
                                    key={slot.appointmentId}
                                    className={`slot-btn ${selectedSlot === slot ? "selected" : ""}`}
                                    onClick={() => setSelectedSlot(slot)}
                                >
                                    {new Date(slot.startDateTime).toLocaleTimeString("en-GB", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: false,
                                        timeZone: "Europe/London"
                                    })}
                                    {" - "}
                                    {new Date(slot.endDateTime).toLocaleTimeString("en-GB", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: false,
                                        timeZone: "Europe/London"
                                    })}
                                </button>
                            ))}
                        </div>
                        <div className="modal-actions">
                            <button className="close-btn" onClick={() => setIsModalOpen(false)}>Close</button>
                            <button
                                className="confirm-btn"
                                onClick={() => handleConfirmSlot(selectedSlot, facilityID, facilityName, address)}
                                disabled={isConfirming}
                            >
                                {isConfirming ? "Confirming..." : "Confirm Slot"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {!loading && (
                <button
                    type="button"
                    className="clinicsslots-directbooking-btn"
                    onClick={() => proceedToPaymentOrSummary(facilityID, facilityName, address, null)}

                >
                    Continue referral to clinic without booking a time
                </button>
            )}
        </div>
    );
};

export default ClinicSlotAvailability;
